import React, { useState, useLayoutEffect } from "react";
import "./Age.css";
import { useNavigate, useLocation } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import Picker from "react-simple-picker";

const Age = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { goal, activity } = location.state || {};
  const [selectedAge, setSelectedAge] = useState(18);
  const [pickerHeight, setPickerHeight] = useState(
    window.innerWidth > 768 ? 400 : 220
  );

  const nextBtnHandler = () => {
    navigate("/height", { state: { goal, activity, age: selectedAge } });
    localStorage.setItem("age", JSON.stringify(selectedAge));
  };

  useLayoutEffect(() => {
    setPickerHeight(window.innerWidth > 768 ? 400 : 220);
  }, []);

  const ages = Array.from({ length: 151 }, (_, index) => index);

  const handleAgeChange = (index) => {
    setSelectedAge(index);
  };

  const customStyle = {
    background: "transparent",
    fontSize: "20px",
    color: "green",
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="age centeredFlex">
            <div className="ageTop">
              <h3 className="ageHeading">سن شما ؟</h3>
              <div className="ageSelectorFiled">
                <Picker
                  height={pickerHeight}
                  initCount={selectedAge}
                  preloadCount={50}
                  iconAdd={null}
                  iconMinus={null}
                  optionGroups={{ year: ages }}
                  valueGroups={{ year: selectedAge }}
                  maxCount={150}
                  minCount={1}
                  onChange={(valueIndex) => handleAgeChange(valueIndex)}
                  renderMask={(Mask) => (
                    <Mask
                      style={{
                        background: "rgba(255, 255, 255, 0.2)",
                        borderRadius: "2rem",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        color: "#fff",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    />
                  )}
                  style={customStyle}
                />
              </div>
            </div>
            <button className="nextQuestion" onClick={nextBtnHandler}>
              بعدی
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Age;
